<template>
    <div>
    <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
        >
        <v-toolbar
        :color="'#5C6BC0'"
        dark
    >    
    <v-toolbar-title>메인 심리테스트</v-toolbar-title>
        <v-spacer/>            
        </v-toolbar>
        <v-list>
        <!-- 유저 아이디  -->
        <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">제목</v-card-title></span>        
        <span style="width:160px"><v-card-title style="font-weight:bold">{{main_test_info.title}}</v-card-title></span>   
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
            <span style="width:160px"><v-card-title style="font-weight:bold">큰배너</v-card-title></span>        
            <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+main_img_path_big" alt="Image"  style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px; margin-bottom: 5px;">
            <span style="width:160px"><v-card-title style="font-weight:bold">작은배너</v-card-title></span>        
            <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+main_img_path_small" alt="Image"  style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px;">
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
            <span style="width:240px"><v-card-title style="font-weight:bold">등록된 테스트 수</v-card-title></span>        
            <span style="width:160px"><v-card-title style="font-weight:bold">{{main_test_info.test_count}}</v-card-title></span>   
            <span style="width:240px"><v-card-title style="font-weight:bold">참여자 수</v-card-title></span>        
            <span style="width:160px"><v-card-title style="font-weight:bold">{{main_test_info.participants}}</v-card-title></span>   
        </v-list-item>
        </v-list>

    </v-card>
    <div style="height:20px"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>심리 테스트</v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="cyan"
            small
            fab
            @click="OnClick_CreateItem"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="bundle_list_all"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.pid}}</td>
            <td>{{row.item.title}}</td>
            <!-- <td :style="{ color: row.item.quiz_count === 0 ? 'red' : 'black' }">
                {{ row.item.quiz_count }}
            </td> -->
            <!-- 추가되는 시작,종료일시 -->
            <!-- //https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/test_img/32hwlkkrhqo.jpg -->
            <td><img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+row.item.img_path_big" alt="Image"  style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"></td>
            <td>[{{row.item.category == 0?'테스트':'찍기' }}] </td>
            <td>{{row.item.test_count}}</td>
            <td>
                <v-btn width="80px"                 
                color="indigo"
                class='white--text'
                @click="OnClickEdit_Item(row.item.pid)">편집</v-btn>
            </td>
            <td>
                <v-btn 
                    width="80px" 
                    :color="row.item.dt_update > row.item.dt_commit ? 'purple' : 'grey'"                     
                    :class="row.item.dt_update > row.item.dt_commit ? 'white--text' : 'black--text'"
                    @click="OnCommitBundle(row.item)"
                    >
                    커밋
                </v-btn>
            </td>
            <td>
                <v-btn 
                width="80px"  
                    :color="row.item.pid == main_test_info.pid? 'yellow' : 'grey'"                     
                    :class="'black--text'"
                    @click="ButtonAction_ItemToMain(row.item)"
                    >
                    메인
                </v-btn>
            </td>
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
            {{ dialog_title_text }}
        </v-card-title>
     
        <v-card-text>
            <v-text-field 
                label="심리테스트 제목"
                v-model="dialog_title" 
                outlined
                dense
            ></v-text-field>
    
    <v-row>
        <v-textarea
          outlined
          name="input-7-4"
          label="부가설명 멘트입력"
          v-model="dialog_desc_text" 
          style="margin-left: 13px;margin-right: 13px; color: gray;"
        ></v-textarea>
    </v-row>
    <v-row>
      <!-- 왼쪽: 이미지 업로드 입력 -->
      <v-col cols="12" md="6">
        <v-file-input
          label="작은 배너(200*120)"
          accept="image/*"
          prepend-icon="mdi-image"
          outlined
          @change="handleFileChange_small"
        />
      </v-col>
      <!-- 왼쪽: 이미지 업로드 입력 -->
      <v-col cols="12" md="6">
        <v-file-input
          label="큰 배너(400*240)"
          accept="image/*"
          prepend-icon="mdi-image"
          outlined
          @change="handleFileChange_big"
        />
      </v-col>
    </v-row>
    <v-row>
    <v-col style="font-size: 16px; font-weight: bold;">참여자수 초기화</v-col>
        <v-text-field 
                label="기본값 0"
                v-model="dialog_participants" 
                outlined
                dense
                hide-details
            ></v-text-field>
         
    </v-row>
    <v-row style="height:30px">    
    </v-row>
    <v-row>
    <v-select
        v-model="dialog_category"
        :items="['심리테스트', '찍기퀴즈']"
        label="타입 선택"
        outlined
        dense
        :value="dialog_category"
    ></v-select>
    </v-row>
    

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="CreateTestBundle"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
const { s3_upload , FileUpload_Async, FileUpload_JSON} = require("../../util/fileutil");
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        search_keyword:'',        
        loadingData:false,        
        create_date:'',
        main_test_info:{},
        main_img_path_big:'',
        main_img_path_small:'',



        dialog : false,
        dialog_title_text :'',
        dialog_title:'',
        dialog_banner_small:null,
        dialog_banner_big:null,
        dialog_participants:0,
        dialog_ismain:false,
        dialog_category:'심리테스트',
        dialog_desc_text:'',


        imageFile_small : null, 
        imageFile_big : null, 
        headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '타이틀', value: 'category' },            
            { text: '배너', value: 'img_path' },           
            { text: '[타입]', value: 'dt_create' },
            { text: '등록테스트', value: 'test_count' },
            { text: '편집하기', value: 'edit' },
            { text: '커밋하기', value: 'commit' },
            { text: '메인으로지정하기', value: 'tomain' },
        ],
        bundle_list_all:[
        ],

        selected_editing_item:{},
    }),

    created()
    {    
        this.LoadTestBundleMain();    
        this.LoadTestBundleList();    
    },

    methods:{
        ...mapActions([
             'CREATE_TEST_BUNDLE',
             'GET_TESTBUNDLE_LIST',
             'GET_TEST_LIST_RESULT',
             'EDIT_TEST_BUNDLE',             
             'DELETE_TEST_BUNDLE',            
            'COMMIT_TESTBUNDLE',
            'SET_TESTBUNDLE_MAIN',
            'GET_TESTBUNDLE_MAIN',
            'GET_TEST_LIST',
        ]),

        LoadTestBundleMain()
        {   
            this.loadingData = true; 
            this.GET_TESTBUNDLE_MAIN({}).then((body_data)=>{
                this.loadingData = false; 
                console.log(JSON.stringify(body_data));
                this.main_test_info = body_data.result;
                
                this.main_img_path_big = this.main_test_info.img_path_big;
                this.main_img_path_small= this.main_test_info.img_path_small;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        LoadTestBundleList(){   
            this.loadingData = true; 
            this.GET_TESTBUNDLE_LIST({}).then((body_data)=>{
                this.loadingData = false; 
                this.bundle_list_all = body_data.result;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        ShowDialog_CreateBundle()
        {
            this.imageFile = null;
            this.dialog = false;    
        },
        async CreateTestBundle()
        {
            if(this.dialog_title == "")
            {
                alert("심리테스트 제목을 입력해주세요");
                return;
            }

            if(this.imageFile_small == null){
                alert("이미지 등록이 필요합니다. 1");
                return;
            }   
            if(this.imageFile_big == null)
            {
                alert("이미지 등록이 필요합니다. 2");
                return;
            }   
            this.loadingData = true;
            this.dialog = false;    

            // dialog_banner_small:null,
            // dialog_banner_big:null,
            var newFileName_small = "snapquiz/test_img/banner/"+this.Utill_CreateNewImageName(this.imageFile_small.name);            
            if(!(await FileUpload_Async(this.imageFile_small, newFileName_small)))
                return;
            if((await FileUpload_Async(this.imageFile_big, newFileName_big)))
            {
                this.loadingData = false;
                        let title = this.dialog_title;
                        let img_path_small = newFileName_small;                
                        let img_path_big = newFileName_big;              
                        let participants  = this.dialog_participants;
                        let desc_text = this.dialog_desc_text;
                        let category = this.dialog_category == "심리테스트"? 0 : 1;
                        this.CREATE_TEST_BUNDLE({title, desc_text , img_path_small , img_path_big, participants, category }).then((body_data)=>{
                            this.LoadTestBundleList();
                        });
            }
        },
        handleFileChange_small(file)
        {
            this.imageFile_small = file;
        },
        handleFileChange_big(file)
        {
            this.imageFile_big = file;
        },


      
        IsItem_Active(item)
        {
            if(item.ENABLE_YN == 'Y')
                return true;
            else
                return false;
        },
        OnClickEdit_Item(item)
        {//아이템을 수정하려는 경우에 호출한다 
            this.$router.push({
                path: '/testedit',
                query: {
                    pid: item,
                }
            });
        },

        OnClick_CreateItem()
        {
            this.dialog_title_text = "심리테스트 제목";
            // 디폴트 시간을 넣어준다.
            this.selected_editing_item = {}; 
            this.dialog = true;
        },

        CancelEdit()
        {
            this.dialog = false;    
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },
        ButtonAction_ItemToMain(item)
        {
            this.loadingData = true;
            let pid = item.pid;
            this.SET_TESTBUNDLE_MAIN({ pid}).then((body_data)=>{
                 this.loadingData = false; 
                this.LoadTestBundleMain();
                this.LoadTestBundleList();                
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },

        async OnCommitBundle(item) {
            try {
                this.loadingData = true;
                let bundle_pid = item.pid;
                console.log("Commit_ 0 _ OnCommitBundle ");

                // 테스트 리스트 가져오기
                const body_data = await this.GET_TEST_LIST({ bundle_pid });
                let item_list_all = body_data.result;
                let newFileName = item.commit_path || "snapquiz/test_data/" + this.Utill_CreateNewImageName('temp.json');

                console.log("Commit_ 1 _ GET_TEST_LIST ");

                // 테스트 결과 리스트 가져오기
                const body_data_result = await this.GET_TEST_LIST_RESULT({ bundle_pid });
                console.log("Commit_ 2 _ GET_TEST_LIST_RESULT ");

                let result_list_all = body_data_result.result.sort((a, b) => b.pid - a.pid);
                let data_container = { "test_data": item_list_all, "result_data": result_list_all };

                // JSON 파일 업로드
                const success = await FileUpload_JSON(data_container, newFileName);
                if (success) {
                    console.log("Commit_ 3 _ FileUpload_JSON ");
                    this.loadingData = false;

                    // 커밋 API 호출
                    const pid = bundle_pid;
                    const commit_path = newFileName;
                    await this.COMMIT_TESTBUNDLE({ pid, commit_path });

                    console.log("Commit_ 4 _ COMMIT_TESTBUNDLE ");
                    this.LoadTestBundleList();
                }
            } catch (err) {
                console.error("❌ OnCommitBundle 오류 발생:", err);
            }
        }

    },
    computed: {
        isLive(){
            return config.isLive;
        },
        noticeStartDate () {
            return `${this.date} ${this.time1}`
        },
        noticeEndDate () {
            return `${this.date2} ${this.time2}`
        },
    },
    components:{
    },
    watch :{
    }
};
</script>
